import { LinkButton } from "@ttc3k/trekker";
import { useTranslation } from "react-i18next";
import { ErrorText } from "../ErrorText";
import { useHelpScout } from "shared/hooks";

export const SimpleErrorNotification = () => {
  const { t } = useTranslation();
  const { handleBeaconClick } = useHelpScout();

  return (
    <ErrorText>
      {t("core:ERROR.ERROR_NOTIFICATION")},&nbsp;
      <LinkButton onClick={() => handleBeaconClick({})}>
        {t("core:ERROR.CONTACT_SUPPORT")}
      </LinkButton>
    </ErrorText>
  );
};
